
































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { getModule } from 'vuex-module-decorators';
import Navigation from '@/store/modules/Navigation';
import { Auth } from "aws-amplify";

//@ts-ignore
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth/lib-esm/Auth";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Urls } from "@/Urls";
import vuetify from '@/plugins/vuetify';

const navigationModule = getModule(Navigation);


@Component({
    components: {}
})
export default class Login extends Vue {
    private readonly Urls = Urls;

    mounted() {
        
    }
}
